import { render } from "./BuildingSpecs.vue?vue&type=template&id=4f8fe0e8&scoped=true"
import script from "./BuildingSpecs.vue?vue&type=script&lang=js"
export * from "./BuildingSpecs.vue?vue&type=script&lang=js"

import "./BuildingSpecs.vue?vue&type=style&index=0&id=4f8fe0e8&scoped=true&lang=scss"

import exportComponent from "/home/forge/mooz360.co.il/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f8fe0e8"]])

export default __exports__